import React, { useMemo } from 'react';
import styles from './SkillPaths.module.scss';
import { Doughnut } from 'react-chartjs-2';
import { Grid } from '@material-ui/core';
import UserAvatars from '../LearningPaths/Components/LearningPathDetails/UserAvatars';
const options = (total) => ({
  plugins: {
    tooltip: {
      enabled: total > 0,
      callbacks: {
        label: function (context) {
          return ` ${context?.label}: ${context?.formattedValue}%`;
        },
      },
    },
    legend: {
      display: false,
    },
  },
  animation: {
    duration: 1,
  },
  maintainAspectRatio: false,
  cutout: '70%',
  radius: '100%',
  cutoutPercentage: 10,
});
const AdminHomeCard = ({ homeData = {} }) => {
  const data = useMemo(() => {
    const fetchChartData = (homeData) => {
      if (homeData?.total_skill_paths_available) {
        return [
          homeData?.percentage_skill_paths_not_started,
          homeData?.percentage_skill_paths_in_progress,
          homeData?.percentage_skill_paths_completed,
        ];
      } else {
        return [1];
      }
    };

    const colors = homeData?.total_skill_paths_available === 0 ? ['#e3e3e3'] : ['#63D2AB', '#F8D783', '#ECEFF1'];

    return {
      labels: ['Completed', 'In Progress', 'Not started'],
      datasets: [
        {
          label: '',
          data: fetchChartData(homeData),
          backgroundColor: colors,
          borderColor: colors,
          hoverBorderColor: colors,
          hoverBackgroundColor: colors,
          hoverBorderWidth: 0,
          hoverBorderRadius: 0,
          hoverOffset: 6,
          borderWidth: 1,
        },
      ],
    };
  }, [homeData]);
  return (
    <div className={styles.progressChart} style={{ boxShadow: 'none' }}>
      <div className={styles.bodyChart}>
        <Grid container direction="row" spacing={1} alignItems="center" justifyContent="center">
          <Grid item md={4} className={styles.chartsMainData}>
            <strong className={styles.totalSkillPaths}>{homeData?.total_skill_paths_available}</strong>
            <div>Skill Paths Available</div>
            <br />
            <UserAvatars users={homeData?.users_who_finished_skill_paths} />
            <div>Finished Skill Paths</div>
          </Grid>
          <Grid item md={4} className={styles.chartDatasets}>
            <ul className="listUnstyled">
              <li className={styles.completed}>
                Completed - <strong>{homeData?.total_skill_paths_completed}</strong>
              </li>
              <li className={styles.inProgress}>
                In Progress - <strong>{homeData?.total_skill_paths_in_progress}</strong>
              </li>
              <li className={styles.yetToStart}>
                Not Started - <strong>{homeData?.total_skill_paths_not_started}</strong>
              </li>
            </ul>
          </Grid>
          <Grid item md={4} style={{ height: '200px', position: 'relative', marginTop: '1.5rem' }}>
            <div className={styles.totalContainer}>
              <h6 className="heading1">{homeData?.total_skill_paths_available}</h6>
              <p className="paragraph">Total</p>
            </div>
            <Doughnut data={data} options={options(homeData?.total_skill_paths_available)} />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default AdminHomeCard;
